export const selectedGroupIdSelector = state => state.setup.admin.adminTreePicker.selectedGroupId;

export const selectedUserIdsSelector = state => state.setup.admin.getUsers.selectedUserIds;

export const adminTreePickerDataSelector = state => state.setup.admin.adminTreePicker;

export const taxContextFilterSelector = state => state.setup.admin.adminTreePicker.taxContextFilter;

export const emailFilterSelector = state => state.setup.admin.adminTreePicker.emailFilter;